import { LOADER } from "constants/action-types";

export const showLoader = (message: string) => {
    if (message) {
        return {
            type: LOADER.SHOW,
            payload: { message },
        };
    }
};

export const hideLoader = (message?: string) => ({
    type: LOADER.HIDE,
    payload: { message },
});
